import { goalsOf } from '../meta/online/boards';
import type { PostRunResponse } from '../meta/online/schema';

type BoardResult = Extract<PostRunResponse, { status: 'ranked' }>['boards'][number];

/**
 * The results' line for a run's place on a board (docs/DAILY_ITEMS.md, part 1): "#4 of 9 today",
 * or for a time equal to the board's best, "Tied the best! (3 players)". The first to post that
 * time stays #1 and reads "#1 of 9, tied by 2". Kept short: the line holds about 28 characters
 * beside its ">".
 */
export function rankText(r: BoardResult, where: string): string {
  if (r.tied) {
    return r.tied.first
      ? `#1 of ${r.total}, tied by ${r.tied.count - 1}`
      : `Tied the best! (${r.tied.count} players)`;
  }
  return `#${r.rank} of ${r.total} ${where}`;
}

/** A goals board's score, short enough for a board row: goals, then the share mowed ("5G 62%"). */
export function goalsScore(value: number): string {
  const { goals, percent } = goalsOf(value);
  return `${goals}G ${percent}%`;
}
